import { Button, Card, Col, ColorPicker, Form, Row, Space } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import CommonUpload from "../../../components/common/upload-image";
import { useDispatch, useSelector } from "react-redux";
import {
  getBrandingData,
  updateBranding,
} from "../../../redux/action/branding/brandingAction";
import { toast } from "react-toastify";
import DropdownSelect from "../../../components/common/select";

const EditBranding = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBrandingData());
  }, []);

  const editDetailsData = useSelector((store) => store.getBrandingData?.data);
  const { isLoading } = useSelector((store) => store.getBrandingData);

  useEffect(() => {
    if (editDetailsData) {
      form.setFieldsValue({
        ...editDetailsData,
        logo: editDetailsData.logo || null,
        primary_color: editDetailsData.primary_color || "#000000",
        font_color: editDetailsData.font_color || "#000000",
        bg_color: editDetailsData.bg_color || "#000000",
        text_color: editDetailsData.text_color || "#000000",
        btn_color: editDetailsData.btn_color || "#000000",
        btn_text_color: editDetailsData.btn_text_color || "#000000",
        default_language: editDetailsData.default_language || null,
      });
    }
  }, [editDetailsData]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      if (!values.logo) {
        toast.error(
          "Logo is mandatory. Please upload a new logo before saving."
        );
        return;
      }
      await dispatch(updateBranding(values, () => navigate(-1)));
    } catch (error) {
      console.log("Validation Failed or API Error:", error);
    }
  };

  const initialFileList = editDetailsData?.logo
    ? [
        {
          uid: "-1",
          name: "logo",
          url: `${process.env.REACT_APP_API_IMG_URI}/${editDetailsData.logo}`,
        },
      ]
    : [];

  const handleUploadSuccess = (field, url) => {
    form.setFieldsValue({ [field]: url });
  };

  const languageList = [
    {label: "English", value: 1},
    {label: "Spanish", value: 2},
    {label: "Portuguese", value: 3}
  ]

  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">Edit Branding</div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()}>
            Save Details
          </Button>
        </Space>
      </div>
      <Card loading={isLoading}>
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Row gutter={16}>
            <Col xs={24} sm={4}>
              <Form.Item name="logo">
                <CommonUpload
                  maxFiles={1}
                  fileLimitSize={2}
                  setFieldValue={(url) => handleUploadSuccess("logo", url)}
                  fileList={initialFileList}
                  showRemoveIcon={true}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={4}>
              <Form.Item name="primary_color" label="Primary Color">
                <ColorPicker
                  value={form.getFieldValue("primary_color")}
                  onChange={(color) =>
                    form.setFieldsValue({ primary_color: color.toHexString() })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={4}>
              <Form.Item name="font_color" label="Primary Text Color">
                <ColorPicker
                  value={form.getFieldValue("font_color")}
                  onChange={(color) =>
                    form.setFieldsValue({ font_color: color.toHexString() })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={4}>
              <Form.Item name="bg_color" label="Background Color">
                <ColorPicker
                  value={form.getFieldValue("bg_color")}
                  onChange={(color) =>
                    form.setFieldsValue({ bg_color: color.toHexString() })
                  }
                />
              </Form.Item>
            </Col>{" "}
            <Col xs={24} sm={4}>
              <Form.Item name="text_color" label="Secondary Text Color">
                <ColorPicker
                  value={form.getFieldValue("text_color")}
                  onChange={(color) =>
                    form.setFieldsValue({ text_color: color.toHexString() })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={4}>
              <Button
                type="primary"
                style={{ padding: "16px 8px", fontSize: "14px" }}
                onClick={() => {
                  form.setFieldsValue({
                    primary_color: "#45AE51",
                    font_color: "#ffffff",
                    bg_color: "#ffffff",
                    text_color: "#000000",
                    btn_color: "#45AE51",
                    btn_text_color: "#ffffff",
                  });
                }}
              >
                Apply Default Theme
              </Button>
            </Col>
            <Col xs={24} sm={4}></Col>
            <Col xs={24} sm={4}>
              <Form.Item name="btn_color" label="Button Color">
                <ColorPicker
                  value={form.getFieldValue("btn_color")}
                  onChange={(color) =>
                    form.setFieldsValue({ btn_color: color.toHexString() })
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={4}>
              <Form.Item name="btn_text_color" label="Button Text Color">
                <ColorPicker
                  value={form.getFieldValue("btn_text_color")}
                  onChange={(color) =>
                    form.setFieldsValue({ btn_text_color: color.toHexString() })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
                <Form.Item
                  name="default_language"
                  label="Default Notification Language"
                  rules={[{ required: true, message: "Select Default Lanugage" }]}
                >
                  <DropdownSelect
                    value={form.getFieldValue("default_language")}
                    onChange={(value) =>
                      form.setFieldsValue({ default_language: value })
                    }
                    options={languageList}
                    placeholder="Choose..."
                  />
                </Form.Item>
              </Col>

          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default EditBranding;
